import { combineReducers } from 'redux';
import appReducer from "./app.js";
import feedReducer from "./feed.js";
import moduleReducer from "./module.js";
import ordersReducer from "./orders.js";
import createReducer from "./create.js";
import sessionReducer from "./session.js";
import signatureReducer from "./signature.js";
export default combineReducers({
  app: appReducer,
  signature: signatureReducer,
  module: moduleReducer,
  feed: feedReducer,
  session: sessionReducer,
  orders: ordersReducer,
  create: createReducer
});